import { ModelBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class ActionPlanChecklistLookup extends ModelBase {
    public actionPlanChecklistHtml: string = "";
    public actionPlanChecklistButtonText: string = "Action Plan Checklist Activity 1 & 2";
    public actionPlanChecklistURL: string ="";
}